import React from "react";
import PropTypes from "prop-types";
import {
  P2,
  P20,
  P200,
  P1000,
  PLUNGER_COLOR_CHART,
} from "../MicroPipette.constants";

/**
 * PipettePlunger:
 *  - Component to display the PipettePlunger
 */
export function PipettePlunger(props) {
  const color = PLUNGER_COLOR_CHART[props.type];
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      fill="none"
      viewBox="0 0 20 24"
      role="img"
      aria-label={props.ariaLabel}
    >
      <g>
        <path fill={color.color1} d="M14 5v19H6V5h8z" />
        <path fill={color.color2} d="M14 5v2H6V5h8z" />
        <path
          fill={color.color3}
          d="M19.92 5H.16C.08 5 0 5 0 4.878V1s0-1 1-1h18c.81 0 .97.776.995.96a.549.549 0 0 1 .005.08v3.838C20 5 20 5 19.92 5z"
        />
        <path
          fill={color.color4}
          d="M1 2.5a.5.5 0 1 1 1 0V5H1V2.5zm4 0a.5.5 0 1 1 1 0V5H5V2.5zm4 0a.5.5 0 1 1 1 0V5H9V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm-14 0a.5.5 0 1 1 1 0V5H3V2.5zm4 0a.5.5 0 1 1 1 0V5H7V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5z"
        />
      </g>
    </svg>
  );
}

PipettePlunger.propTyeps = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Type of MicroPipette
   */

  type: PropTypes.oneOf([P2, P20, P200, P1000]),
};

PipettePlunger.defaultProps = {
  className: "",
  type: P2,
};
